<template>
  <div id="add_bank" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 class="mb-0">Add Bank</h4>
          </div>
          <button
            type="button"
            class="close"
            @click="closeAddModal()"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="addBank">
            <div class="form-group">
              <label>Bank name <span class="text-danger">*</span></label>

              <select
                v-if="currency === 'NGN'"
                class="form-select"
                :disabled="isResolving"
                @change="setCode()"
                v-model="form.bank_name"
              >
                <option value="">Select Bank</option>
                <option
                  v-for="(bank, index) in bank_list"
                  :key="index"
                  :value="bank.name"
                >
                  {{ bank.name }}
                </option>
              </select>

              <input
                v-else
                v-model="form.bank_name"
                class="form-control"
                type="text"
                required
              />
            </div>
            <div class="form-group">
              <label>Account number <span class="text-danger">*</span></label>
              <div class="name-wrapper">
                <input
                  v-model="form.account_number"
                  :disabled="isResolving"
                  type="text"
                  @input="fetchAccount()"
                  class="form-control"
                  required
                />
                <b-spinner
                  v-if="isResolving"
                  small
                  label="Small Spinner"
                  class="resolve-spinner"
                ></b-spinner>
              </div>
            </div>
            <div class="form-group">
              <label>Account name <span class="text-danger">*</span></label>
              <input
                v-model="form.account_name"
                class="form-control bg-white"
                :disabled="currency === 'NGN'"
                type="text"
                required
              />
            </div>
            <div class="form-group">
              <label>Additional Information </label>
              <textarea
                v-model="form.other_info"
                class="form-control"
                type="text"
              ></textarea>
            </div>

            <!-- <label
              class="custom_check text-dark fw-medium mb-3"
              style="font-weight: 500"
            >
              <input
                type="checkbox"
                v-model="form.preferred"
                true-value="1"
                false-value="0"
                name="recurring"
              />
              <span class="checkmark"></span> Set as preferred
            </label> -->

            <div class="submit-section">
              <button
                :disabled="isLoading || isResolving"
                type="submit"
                class="btn btn-primary add-tax-save-btn"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span v-if="!isLoading">Add Bank</span>
                <span v-if="isLoading">Adding...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed} from "vue";
import { useStore } from "vuex";

const store = useStore();
const isLoading = ref(false);
const isResolving = ref(false)
const currency = localStorage.getItem('currency')

const emits = defineEmits(['close'])

const resetForm = () => {
  form.value = {
    bank_name: "",
    account_name: "",
    account_number: "",
    preferred: 1,
    other_info: "",
  };
};

const form = ref({
  bank_name: "",
  account_name: "",
  account_number: "",
  preferred: 1,
  ifsc_code: "",
});

const bank_code = ref(null)

const setCode = () => {
  const selectedBank = bank_list.value.find(bank => bank.name === form.value.bank_name)
	bank_code.value = selectedBank.code
  fetchAccount()
}

const fetchAccount = () => {
	if (currency === 'NGN' && form.value.account_number.length == 10 && bank_code.value !== null) {
    resolveBank()
	}
}

const bank_list = computed(() => {
  return store.getters["settings/bank_list"];
});
const resolved_bank = computed(() => {
  return store.getters["settings/resolved_bank"];
});

const closeAddModal = () => {
  emits('close')
  resetForm()
}

const resolveBank = async () => {
	isResolving.value = true
	let data = {
		acc_no: form.value.account_number,
		bank_code:bank_code.value
	}
  await store
	  .dispatch("settings/resolveBank",data).then(() => {
		  form.value.account_name = resolved_bank.value.account_name
		isResolving.value = false
	  }).catch(() => {
		  isResolving.value = false
		form.value.account_name = ''
	})
};

const addBank = () => {
  isLoading.value = true;
  store
    .dispatch("settings/addBankAccount", form.value)
    .then(() => {
      isLoading.value = false;
      closeAddModal();
      store.dispatch("settings/getSettings")
    })
    .catch(() => {
      isLoading.value = false;
    });
};
</script>

<style scoped>
.name-wrapper{
	position: relative;
}

.resolve-spinner{
	position: absolute;
	top: 13px;
	right: 10px;
	color: #3865b0;
}
</style>